<template>
    <CSidebar
        color-scheme="light"
        position="fixed"
        :visible="true"
        :unfoldable="false"
    >
        <CSidebarBrand
            class="d-md-down-none"
            to="/"
        >
            <img
                :src="$page.props.ownerGroupLogoUrl ?? '/img/logo.dogado.svg'"
                class="c-sidebar-brand-full py-1"
            >
        </CSidebarBrand>

        <CSidebarNav>
            <div
                v-for="(sidebarItem) in sidebarItems"
                :key="sidebarItem.route"
            >
                <CNavItem
                    v-if="sidebarItem.isStandaloneItem && hasPermission(sidebarItem.permissions)"
                >
                    <Link
                        :href="$route().has(sidebarItem.children[0].route) ? $route(sidebarItem.children[0].route) : ''"
                        :class="currentRouteInfo.activeRoutes.includes(sidebarItem.children[0].route) ? 'activeItem' : ''"
                        class="nav-link"
                    >
                        <DIcon
                            v-if="sidebarItem.icon"
                            :name="sidebarItem.icon"
                            class="c-sidebar-nav-icon"
                        />
                        {{ sidebarItem.label }}
                    </Link>
                </CNavItem>
                <CNavGroup
                    v-if="!sidebarItem.isStandaloneItem && hasPermission(sidebarItem.permissions)"
                >
                    <template #togglerContent>
                        <DIcon
                            v-if="sidebarItem.icon"
                            :name="sidebarItem.icon"
                            class="c-sidebar-nav-icon"
                        />
                        {{ sidebarItem.label }}
                    </template>
                    <p
                        v-for="(sidebarChildItem, key) in sidebarItem.children"
                        :key="key"
                        class="mb-0"
                    >
                        <CNavItem
                            v-if="sidebarChildItem.showInSidebar === true && hasPermission(sidebarChildItem?.permissions)"
                        >
                            <Link
                                :href="$route().has(sidebarChildItem.route) ? $route(sidebarChildItem.route) : ''"
                                :class="currentRouteInfo.activeRoutes.includes(sidebarChildItem.route) ? 'activeItem' : ''"
                                class="nav-link"
                            >
                                {{ sidebarChildItem.label }}
                            </Link>
                        </CNavItem>
                    </p>
                </CNavGroup>
            </div>
            <DSidebarVersionInfo />
        </CSidebarNav>
        <CSidebarToggler />
    </CSidebar>
</template>

<script>
import sitemap from '~@/Configurations/sitemap/sitemap'
import { getActiveSidebarItem } from '~@/Configurations/sitemap'
import DSidebarVersionInfo from '~@/Components/App/Sidebar/DSidebarVersionInfo'
import { usePage } from '@inertiajs/vue3'
import { CNavGroup, CNavItem, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/vue-pro'

export default {
    name: 'Sidebar',
    components: {
        DSidebarVersionInfo,
        CSidebar,
        CSidebarBrand,
        CSidebarNav,
        CNavItem,
        CNavGroup,
        CSidebarToggler
    },
    props: {
        minimized: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            sidebarItems: [],
            currentRouteInfo: {
                activeRoutes: [],
                expandDropdowns: []
            }
        }
    },
    computed: {
        userPermissions () {
            return usePage().props.auth.permissions
        }
    },
    mounted () {
        this.loadSidebar()

        this.emitter.on('select-sidebar', () => {
            this.currentRouteInfo.activeRoutes = []
            this.currentRouteInfo.expandDropdowns = []
            this.getCurrentRouteInfo()
        })
    },
    methods: {
        getCurrentRouteInfo () {
            this.currentRouteInfo = getActiveSidebarItem(sitemap(this.$t), this.$route().current())
        },
        toggleMinimizer () {
            this.emitter.emit('sidebar-toggle')
        },
        loadSidebar () {
            this.sidebarItems = sitemap(this.$t)
            this.getCurrentRouteInfo()
        },
        hasPermission (permissions) {
            if (permissions === undefined) return true
            return permissions.some(item => this.userPermissions.includes(item))
        }
    }
}
</script>

<style lang="scss">
.padding {
    padding-left: 15px
}
.sidebar {
    & .nav-link:hover {
        background: var(--colorPrimary) !important;
    }

    & .sidebar-brand {
        background: #fff !important;
        padding: 25px 0px;

        & img {
            height: 40px;
        }
    }

    & .nav-link {
        color: rgba(0, 0, 21, .8) !important;
    }

    & .nav-item {
        & .nav-link {
            &:hover {
                background: var(--colorPrimary) !important;
                color: var(--colorPrimaryText) !important;

                & .c-sidebar-nav-icon {
                    color: var(--colorPrimaryText) !important;
                }
            }
        }
    }

    & .c-sidebar-nav-icon {
        margin-left: -1rem;
        flex: 0 0 56px;
    }

    & .sidebar-nav .nav-group-items .nav-link {
        padding-left: 56px;
    }
}
.activeItem {
    background: var(--colorPrimary) !important;
    color: var(--colorPrimaryText) !important;

    &::after {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='rgba(0,0,0,0.2)' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/svg%3E");
    }
    & .c-sidebar-nav-icon {
        color: var(--colorPrimaryText) !important;
    }
}
</style>
